import Pile from "./Pile";
import Constants from "../../constants/Constants";

export default class UsedPile extends Pile {
    constructor(gameCtx, entityIndex, args) {
        super(gameCtx, entityIndex, args);
        this.cardSideShown = true;
    }

    calcRotateDeg = (cardObj = null, index) => {
        let deg = 0, currentDeg = 0, prefix = 1, rand = 0;

        if (cardObj.ref.current != null) {
            currentDeg = cardObj.ref.current.getCurrentDeg();
        }

        if (index !== 0) {
            let max = 15;
            rand = Math.floor(Math.random() * (max + 1));

            max = 1;
            let r = Math.floor(Math.random() * (max + 1));
            prefix = r === 0 ? -1 : 1;
        }

        switch (currentDeg) {
            case Constants.CARD_DEG_VERTICAL_TOP: deg = 0 + (rand * prefix); break;
            case Constants.CARD_DEG_VERTICAL_BOTTOM: deg = 180 + (rand * prefix); break;
            case Constants.CARD_DEG_HORIZONTAL_RIGHT: deg = 270 + (rand * prefix); break;;
            case Constants.CARD_DEG_HORIZONTAL_LEFT: deg = 90 + (rand * prefix); break;
            default: deg = 0 + (rand * prefix); break;
        }
        return deg;
    }

    resetInitialCoords = () => {
        this.firstCardCoords = this.gameCtx.pilesContainer.getUsedPilePositions()
    }
}